import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OneQmsAuthService } from '../auth/one-qms-auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private readonly router: Router,
    private readonly authService: OneQmsAuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    console.log("AUTH GUARD CHECKING");
    return this.authService.validateSession().pipe(

      map(() => { return true; }),

      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
